module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/msci2-c991a98949d7ca28c237e41f85e10f73.jpg";